module.exports = __webpack_public_path__ + "static/cookies-policy-f290b71bcaa0402f2818c21692ec535a.svg";